/* ============================================================
   LIVRARIA — Produtos vistos recentemente (localStorage)
   Registra o produto atual (window.LFCRecent.current) e
   renderiza nos elementos <recently-viewed>. Código original.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'lfc_recently_viewed';
  var MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'BRL';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function hydrate(list) {
    return Promise.all(list.map(function (item) {
      if (
        typeof item.priceCents === 'number' &&
        Object.prototype.hasOwnProperty.call(item, 'compareAtCents') &&
        item.variantId &&
        typeof item.available === 'boolean' &&
        typeof item.hasOnlyDefaultVariant === 'boolean'
      ) {
        return item;
      }

      return fetch(item.url + '.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('product unavailable');
          return response.json();
        })
        .then(function (data) {
          var variant = (data.variants || []).filter(function (candidate) { return candidate.available; })[0]
            || (data.variants || [])[0]
            || data;
          var price = Number(variant.price || data.price || 0);
          var compareAt = Number(variant.compare_at_price || data.compare_at_price || 0);
          item.productId = data.id || item.productId;
          item.variantId = variant.id || item.variantId;
          item.hasOnlyDefaultVariant = (data.variants || []).length === 1;
          item.available = Boolean(variant.available);
          item.vendor = data.vendor || item.vendor || '';
          item.priceCents = price;
          item.compareAtCents = compareAt > price ? compareAt : null;
          item.price = formatMoney(price);
          item.compareAt = compareAt > price ? formatMoney(compareAt) : null;
          return item;
        })
        .catch(function () { return item; });
    }));
  }

  function track() {
    var cur = window.LFCRecent && window.LFCRecent.current;
    if (!cur || !cur.handle) return;
    var list = read().filter(function (p) { return p.handle !== cur.handle; });
    list.unshift(cur);
    write(list.slice(0, MAX));
  }

  function render() {
    var hosts = document.querySelectorAll('recently-viewed');
    var list = read();
    hosts.forEach(function (host) {
      var grid = host.querySelector('[data-recent-grid]');
      if (!grid) return;
      var exclude = host.getAttribute('data-exclude') || '';
      var limit = parseInt(host.getAttribute('data-limit'), 10) || 4;
      var items = list.filter(function (p) { return p.handle !== exclude; }).slice(0, limit);
      if (!items.length) { host.style.display = 'none'; return; }
      grid.innerHTML = items.map(function (p) {
        var hasDiscount = p.compareAt && Number(p.compareAtCents || 0) > Number(p.priceCents || 0);
        var discount = hasDiscount
          ? Math.round((Number(p.compareAtCents) - Number(p.priceCents)) * 100 / Number(p.compareAtCents))
          : 0;
        var canAdd = p.available !== false && p.variantId && p.hasOnlyDefaultVariant !== false;
        return (
          '<li class="rv__item">' +
            '<article class="home-card" data-home-product-card data-product-id="' + escapeHtml(p.productId) + '" data-product-handle="' + escapeHtml(p.handle) + '" data-variant-id="' + escapeHtml(p.variantId) + '">' +
              '<a class="home-card__media" href="' + escapeHtml(p.url) + '" data-home-product-link>' +
                (p.image ? '<img class="home-card__image" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
                (hasDiscount ? '<span class="home-card__discount">-' + discount + '%</span>' : '') +
              '</a>' +
              '<div class="home-card__content">' +
                '<a class="home-card__title" href="' + escapeHtml(p.url) + '" data-home-product-link>' + escapeHtml(p.title) + '</a>' +
                (p.vendor ? '<p class="home-card__vendor">' + escapeHtml(p.vendor) + '</p>' : '') +
                '<div class="home-card__price"><strong>' + escapeHtml(p.price || '') + '</strong>' +
                  (hasDiscount ? '<s>' + escapeHtml(p.compareAt) + '</s>' : '') +
                '</div>' +
                '<div class="home-card__actions">' +
                  (canAdd
                    ? '<form method="post" action="' + escapeHtml(host.getAttribute('data-cart-add-url') || '/cart/add') + '" class="home-card__form" data-home-quick-add>' +
                        '<input type="hidden" name="id" value="' + escapeHtml(p.variantId) + '">' +
                        '<input type="hidden" name="quantity" value="1">' +
                        '<div class="home-card__stepper" data-home-stepper>' +
                          '<button type="button" aria-label="Diminuir quantidade" data-home-quantity-minus>−</button>' +
                          '<output aria-live="polite" data-home-quantity>1</output>' +
                          '<button type="button" aria-label="Aumentar quantidade" data-home-quantity-plus>+</button>' +
                        '</div>' +
                        '<button class="home-card__add" type="submit">Adicionar</button>' +
                      '</form>'
                    : '<a class="home-card__options" href="' + escapeHtml(p.url) + '">' + (p.available === false ? 'Esgotado' : 'Ver opções') + '</a>') +
                '</div>' +
              '</div>' +
            '</article>' +
          '</li>'
        );
      }).join('');
      host.style.display = '';
      host.dispatchEvent(new CustomEvent('lfc:home_cards_updated', { bubbles: true }));
    });
  }

  function init() {
    track();
    hydrate(read()).then(function (list) {
      write(list);
      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
